import { createContext, useContext, useEffect, useState } from "react";
import request from "../../services/Request";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const userInfo = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;
  const [user, setUser] = useState(userInfo);
  const [gitf, setGitf] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);

  // useEffect(() => {
  //   console.log("setusinger", user);
  // }, [user]);

  useEffect(() => {
    if (userInfo) {
      request({
        method: "post",
        url: "/clientUser/fetchUser",
        data: {
          _id: userInfo._id,
        },
      })
        .then((res) => {
          console.log("user", res.data?.foundUser);
          localStorage.setItem("user", JSON.stringify(res.data?.foundUser));
          setUser(res.data?.foundUser);
          if (res.data?.clientPromo) {
            setGitf(res.data?.clientPromo);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [refresh]);

  const value = {
    user,
    setUser,
    loading,
    setLoading,
    refresh,
    setRefresh,
    gitf,
    setGitf,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

// Custom hook to use the auth context
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
